import Loadable from 'react-loadable'

import Loader from '~/components/Loading/Splash'

export default Loadable({
  loader: () => import('./Router'),
  loading: Loader,
})
